// src/components/Expenses/ExpensesToolbar.js
import React from "react";
import { Box, Button, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

const STATUS_FILTER_OPEN = "open";
const STATUS_FILTER_CLOSED = "closed";
const STATUS_FILTER_ALL = "all";

const ExpensesToolbar = ({ onCreate, statusFilter, onStatusFilterChange }) => {
  return (
    <Box sx={{ mb: 2, display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 2 }}>
      <FormControl size="small" sx={{ minWidth: 160 }}>
        <InputLabel id="expenses-status-filter-label">Ver estado</InputLabel>
        <Select
          labelId="expenses-status-filter-label"
          id="expenses-status-filter"
          value={statusFilter}
          label="Ver estado"
          onChange={(e) => onStatusFilterChange(e.target.value)}
        >
          <MenuItem value={STATUS_FILTER_OPEN}>Abiertos</MenuItem>
          <MenuItem value={STATUS_FILTER_CLOSED}>Cerrados</MenuItem>
          <MenuItem value={STATUS_FILTER_ALL}>Todos</MenuItem>
        </Select>
      </FormControl>
      <Button variant="contained" startIcon={<AddIcon />} onClick={onCreate}>
        Nuevo documento
      </Button>
    </Box>
  );
};

export default ExpensesToolbar;
export { STATUS_FILTER_OPEN, STATUS_FILTER_CLOSED, STATUS_FILTER_ALL };
